import { INLINE_DISCLOSURE } from "../../../utils/helpers/clientQuestionnaire.helper.js";

import Card from "../../Card";

const InlineDisclosuresCard = () => {
  return (
    <Card id="client-questionnaire__inline-disclosure-card" openByDefault>
      <div className="card__content">
        <p className="inline-disclosures">{INLINE_DISCLOSURE}</p>
      </div>
    </Card>
  );
};

InlineDisclosuresCard.propTypes = {};
InlineDisclosuresCard.defaultValues = {};

export default InlineDisclosuresCard;
